import CheckoutBoxHeader from "../CheckoutBoxHeader";
import { DeliveryMethodsTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  deliveryMethods: DeliveryMethodsTypes[];
  mobile: boolean;
  isPopUp?: boolean;
}

const ReceivingMethodsHeader: React.FC<Props> = ({
  deliveryMethods,
  mobile,
  isPopUp,
}) => {
  const t = useTranslation();
  if (deliveryMethods?.length > 1)
    return !isPopUp ? (
      <CheckoutBoxHeader title={t.receiving_method} mobile={mobile} />
    ) : (
      <div className="delivery-Methodes-title">
        {t.please_select_your_preferred_receiving_settings}{" "}
      </div>
    );
  else if (deliveryMethods?.[0] === DeliveryMethodsTypes.delivery)
    return <CheckoutBoxHeader title={t.address} mobile={mobile} />;
  else return <CheckoutBoxHeader title={t.pickup_address} mobile={mobile} />;
};

export default ReceivingMethodsHeader;
